let pinchZoomContainer = null

const doubleTap = (element) => {
  let lastTap = 0
  let timeout

  const reset = function () {
    clearTimeout(timeout)
  }
  const listener = function (event) {
    if (event.touches.length !== 0) {
      clearTimeout(timeout)
      return
    }
    // event.preventDefault()

    const currentTime = new Date().getTime()
    const tapLength = currentTime - lastTap

    clearTimeout(timeout)

    if (tapLength > 50 && tapLength < 500) {
      event.target.dispatchEvent(new Event('doubletap'))
      lastTap = 0
      return
    } else {
      timeout = setTimeout(() => {
        clearTimeout(timeout)
      }, 500)
    }
    lastTap = currentTime
  }
  element.addEventListener('touchend', listener)
  element.addEventListener('click', listener)
  element.addEventListener('touchmove', reset)
  return element
}

export const pinchZoom = (container) => {
  let lastScale = 1
  let lastX = 0
  let lastY = 0

  let imageElementScale = 1
  let deltaX
  let deltaY

  interface StartPos {
    x?: number,
    y?: number,
    distance: number
  }
  const start: StartPos = {
    x: 0,
    y: 0,
    distance: 0
  }

  const cleanUpListeners = (imageElement) => {
    imageElement.removeEventListener('touchmove', touchmoveHandler)
    imageElement.removeEventListener('touchend', finalizeTransform)
  }

  const getPosition = (event, attribute) => {
    let pos = event.touches[0][attribute]
    if (event.touches[1]) {
      pos += event.touches[1][attribute]
    }
    return pos
  }

  // Calculate distance between two fingers
  const distance = (event) => {
    return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY)
  }

  const finalizeTransform = (event) => {
    cleanUpListeners(imageElement)

    lastX = deltaX ?? 0
    lastY = deltaY ?? 0
    lastScale = imageElementScale

    start.x = null
    start.y = null
  }

  const touchmoveHandler = (event) => {
    if (!start.x || !start.y) {
      return
    }
    event.preventDefault()

    // Safari provides event.scale as two fingers move on the screen
    // For other browsers just calculate the scale manually
    if (event.touches.length === 2) {
      let scale
      if (event.scale) {
        scale = event.scale
      } else {
        const deltaDistance = distance(event)
        scale = deltaDistance / start.distance
      }
      scale *= lastScale
      imageElementScale = Math.min(Math.max(1, scale), 4)
    }

    // Calculate how much the fingers have moved on the X and Y axis
    deltaX = ((getPosition(event, 'pageX') / 2) - start.x) * 2 + lastX // x2 for accelarated movement
    deltaY = ((getPosition(event, 'pageY') / 2) - start.y) * 2 + lastY // x2 for accelarated movement

    const limitX = imageElement.offsetWidth * (imageElementScale - 1) / 2
    deltaX = deltaX > 0 ? Math.min(deltaX, limitX) : Math.max(deltaX, limitX * -1)
    const limitY = imageElement.offsetHeight * (imageElementScale - 1) / 2
    deltaY = deltaY > 0 ? Math.min(deltaY, limitY) : Math.max(deltaY, limitY * -1)

    // Transform the image to make it grow and move with fingers
    applyTransform(deltaX, deltaY, imageElementScale)
  }

  const imageElement = container.querySelector('img')

  if (pinchZoomContainer) {
    cleanUpListeners(imageElement)
  }
  pinchZoomContainer = container

  const applyTransform = (x, y, scale) => {
    const transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`
    imageElement.style.transform = transform
    imageElement.style.WebkitTransform = transform
    imageElement.style.zIndex = '9999'
  }

  const reset = () => {
    imageElement.style.transform = ''
    imageElement.style.WebkitTransform = ''
    imageElement.style.zIndex = ''
  }

  const touchStartHandler = (event) => {
    if (event.touches.length === 1 && imageElementScale === 1) {
      return // if not zoomed in, do not handle 1 finger
    }
    event.preventDefault()

    // Calculate where the fingers have started on the X and Y axis
    start.x = getPosition(event, 'pageX') / 2
    start.y = getPosition(event, 'pageY') / 2

    if (event.touches.length === 2) {
      start.distance = distance(event)
    }

    imageElement.addEventListener('touchmove', touchmoveHandler)
    imageElement.addEventListener('touchend', finalizeTransform)
    doubleTap(imageElement).addEventListener('doubletap', doubleTapHandler)
  }

  const doubleTapHandler = (event) => {
    const newScale = (imageElementScale === 1) ? 3 : 1
    imageElementScale = newScale
    applyTransform(0, 0, newScale)
    finalizeTransform(event)
  }

  imageElement.addEventListener('touchstart', touchStartHandler)

  return this
}

/*
window.addEventListener('load', function () {
  pinchZoom(document.querySelector('.container'))
})
*/
